import { MutableRefObject } from 'react';
import { errorService } from 'services';
import { HttpResponseError } from 'lib/error/http-response-error';
import { HttpStatusEnum } from 'lib/enum/http-status.enum';
import { ABORT_CONTROLLER_SIGNAL_ABORTED_MESSAGE } from './config';

export const withErrorHandler = async <T = void>(callback: () => Promise<T>): Promise<T | void> => {
    try {
        return await callback();
    } catch (error) {
        processErrorWithoutAbortionError(error, error => errorService.add(error));
    }
};

export const processErrorWithoutAbortionError = (error: any, processError: (err: any) => void): any => {
    if (error instanceof Error && error.message === ABORT_CONTROLLER_SIGNAL_ABORTED_MESSAGE) {
        return;
    } else {
        processError(error);
    }
};

export const silentForbiddenErrorHandler = async <T = void>(callback: () => Promise<T>): Promise<T | void> => {
    try {
        return await callback();
    } catch (error) {
        if (!(error instanceof HttpResponseError && error?.response?.status === HttpStatusEnum.FORBIDDEN)) {
            processErrorWithoutAbortionError(error, error => errorService.add(error));
        }
    }
};

export const silentWithErrorHandler = async <T = void>(callback: () => Promise<T>): Promise<T | void> => {
    if (navigator.onLine) {
        try {
            return await callback();
        } catch {
            /**
             * User can be offline. Do nothing.
             */
        }
    }
};

export const withAbortHandler = async <T = void>(
    callback: () => Promise<T>,
    abortControllerRef: MutableRefObject<AbortController | null>,
): Promise<T | void> => {
    abortControllerRef.current?.abort();
    abortControllerRef.current = new AbortController();
    try {
        return await callback();
    } catch (e) {
        /**
         * User aborted request. Do nothing.
         */
    }
};
